module.exports = __webpack_public_path__ + "static/media/tas-networks.b8db40c7.png";